import { render, staticRenderFns } from "./news3.vue?vue&type=template&id=0a27b7d6&scoped=true"
import script from "./news3.vue?vue&type=script&lang=ts"
export * from "./news3.vue?vue&type=script&lang=ts"
import style0 from "./news3.vue?vue&type=style&index=0&id=0a27b7d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27b7d6",
  null
  
)

export default component.exports